export default{
    DELETE_REMINDER_SUCCESS_MESSAGE : "Reminder deleted successfully",
    DELETE_REMINDER_FAILURE_MESSAGE : "Deleting reminder failed",
    ADD_REMINDER_SUCCESS_MESSAGE : "Reminder added successfully",
    ADD_REMINDER_FAILURE_MESSAGE : "Adding Reminder failed",
    EDIT_REMINDER_SUCCESS_MESSAGE : "Reminder updated successfully",
    EDIT_REMINDER_FAILURE_MESSAGE : "Update reminder failed"
}